import Vue from "vue";
import VueResource from "vue-resource";
import { API_ROOT } from "../config";

Vue.use(VueResource);

// Vue.http.options.crossOrigin = true
// Vue.http.options.credentials = true

/*if (process.env.NODE_ENV === "production") {
  throw new Error("Missing API root");
  // Vue.http.options.root = ...
}*/

Vue.http.interceptors.push((request, next) => {
  request.headers = request.headers || {};
  const supportToken = sessionStorage.getItem("SupportAuthorization");
  const isSupportWindow = sessionStorage.getItem("SupportWindow") === "1";
  const token = supportToken || (isSupportWindow ? null : localStorage.getItem("Authorization"));
  if (token) request.headers.set("Authorization", token);
  next(response => {
    if (response.status === 401) {
      if (!window.location.pathname === "/login")
        window.location.pathname = "/login";
    }
  });
});

export const AuthResource = Vue.resource(API_ROOT + "auth");
export const SignUpResource = Vue.resource(API_ROOT + "signup");
export const ActivateAccountResource = Vue.resource(
  API_ROOT + "activate/{token}"
);
export const MySelfResource = Vue.resource(API_ROOT + "myself");
export const SupportSessionCreateResource = Vue.resource(API_ROOT + "admin/support-session");
export const SupportSessionExchangeResource = Vue.resource(API_ROOT + "auth/support-session");
export const SupportSessionEndResource = Vue.resource(API_ROOT + "auth/support-session");
export const SyncRevisionsResource = Vue.resource(API_ROOT + "sync/revisions");
export const ForgotPasswordResource = Vue.resource(
  API_ROOT + "forgot_password"
);
export const ResetPasswordResource = Vue.resource(
  API_ROOT + "reset_password"
);
export const DeviceResource = Vue.resource(API_ROOT + "device");
export const DeviceOnlyResource = Vue.resource(API_ROOT + "device/only");
export const DeviceAllResource = Vue.resource(API_ROOT + "device/all");
export const DeviceSuspiciousAnalysisResource = Vue.resource(API_ROOT + "device/suspicious-analysis");
export const DeviceSuspiciousEventsResource = Vue.resource(API_ROOT + "device/suspicious-analysis/{id}/events");
export const DeviceTestResetPreviewResource = Vue.resource(API_ROOT + "device/test-reset/{id}/preview");
export const DeviceTestResetExecuteResource = Vue.resource(API_ROOT + "device/test-reset/{id}/execute");
export const DeviceLocationUpdateResource = Vue.resource(API_ROOT + "device/location/{id}");
export const DeviceActivateDryRunResource = Vue.resource(API_ROOT + "device/activate/{id}");
export const DeviceMigrateResource = Vue.resource(API_ROOT + "device/migrate/{id}");
export const DevicePrepareDirectMqttResource = Vue.resource(API_ROOT + "device/prepare-direct-mqtt/{id}");
export const DeviceConfigUpdateResource = Vue.resource(API_ROOT + "device/config/{id}");
export const SolartrackerCanDisplayResource = Vue.resource(API_ROOT + "device/solartracker-can-display/{id}");
export const DeviceSetreducedCommandsResource = Vue.resource(API_ROOT + "device/setreduced-commands/{id}");
export const DeviceUpdateResource = Vue.resource(API_ROOT + "device/{id}");
export const DeviceDeleteResource = Vue.resource(API_ROOT + "device/{id}");
export const DeviceGetResource = Vue.resource(API_ROOT + "device/{id}");
export const DeviceGetDebugValuesResource = Vue.resource(API_ROOT + "device/debug_values/{id}");
export const DeviceGetIFrameResource = Vue.resource(API_ROOT + "device/iframe/{id}");

export const DeviceEventResource = Vue.resource(
  API_ROOT + "device{/deviceId}/event"
);
export const LocationEventIndexResource = Vue.resource(
  API_ROOT + "event{/deviceId}/index"
);
//export const MQTTSetHTResource = Vue.resource(API_ROOT + "mqtt/setht");
//export const MQTTSetNTResource = Vue.resource(API_ROOT + "mqtt/setnt");
//export const MQTTallAwakeResource = Vue.resource(API_ROOT + "mqtt/allawake");
export const MQTTdeviceConsoleResource = Vue.resource(API_ROOT + "mqtt/device-console/{id}");
export const MQTTbrokerAccessOverviewResource = Vue.resource(API_ROOT + "mqtt/broker-access");
export const MQTTbrokerAccessDeviceResource = Vue.resource(API_ROOT + "mqtt/broker-access/{id}");
export const MQTTfirmwareChecksumResource = Vue.resource(API_ROOT + "mqtt/firmware-checksum");
export const MQTTPermissionRequestResource = Vue.resource(API_ROOT + "mqtt/permission-request");
export const MQTTPermissionRequestActionResource = Vue.resource(API_ROOT + "mqtt/permission-request/{id}/{action}");
export const MQTTPermissionDeviceActionResource = Vue.resource(API_ROOT + "mqtt/permission-request/device/{id}/{action}");
export const MQTTClaimRequestResource = Vue.resource(API_ROOT + "mqtt/claim-request");
export const MQTTClaimRequestActionResource = Vue.resource(API_ROOT + "mqtt/claim-request/{id}/{action}");
export const MQTTrescueOtaResource = Vue.resource(API_ROOT + "mqtt/rescue-ota/{id}");
export const MQTTrescueProvisionResource = Vue.resource(API_ROOT + "mqtt/rescue-provision/{id}");
export const MQTTotaNextionResource = Vue.resource(API_ROOT + "mqtt/ota-nextion/{id}");
export const MQTTdeviceConsoleStreamCloseResource = Vue.resource(API_ROOT + "mqtt/device-console-stream/close");
export const MQTTsetDeviceResource = Vue.resource(API_ROOT + "mqtt/setdevice");
export const ModbusGatewayConfigReadResource = Vue.resource(API_ROOT + "mqtt/modbus-gateway/{id}/config/read");
export const ModbusGatewayConfigResource = Vue.resource(API_ROOT + "mqtt/modbus-gateway/{id}/config");
export const ModbusGatewayTransactionResource = Vue.resource(API_ROOT + "mqtt/modbus-gateway/{id}/transaction");

export const CreatePersonResource = Vue.resource(API_ROOT + "person");
export const PersonResource = Vue.resource(API_ROOT + "person");
export const PersonDeleteResource = Vue.resource(API_ROOT + "person/{id}");
export const PersonDeactivateResource = Vue.resource(API_ROOT + "person/deactivate/{id}");
export const PersonUpdateResource = Vue.resource(API_ROOT + "person/{id}");
export const PersonHistoryResource = Vue.resource(API_ROOT + "person/{id}");

export const LocationResource = Vue.resource(API_ROOT + "location");
export const LocationCreateResource = Vue.resource(API_ROOT + "location");
export const LocationUpdateResource = Vue.resource(API_ROOT + "location/{id}");
export const LocationDeleteResource = Vue.resource(API_ROOT + "location/{id}");
export const LocationSecretRevealResource = Vue.resource(API_ROOT + "location/{id}/secret/reveal");
export const LocationSecretSetResource = Vue.resource(API_ROOT + "location/{id}/secret");
export const HeatcontrolMultiPreviewResource = Vue.resource(API_ROOT + "heatcontrol/configuration/preview");
export const HeatcontrolApartmentSupplyResource = Vue.resource(API_ROOT + "heatcontrol/apartment-supply");
export const HeatcontrolApartmentConsumptionResource = Vue.resource(API_ROOT + "heatcontrol/apartment/{apartmentId}/consumption");
export const HeatcontrolApartmentDeviceResource = Vue.resource(API_ROOT + "heatcontrol/apartment/{apartmentId}/device");
export const HeatcontrolTemperatureControlResource = Vue.resource(API_ROOT + "heatcontrol/apartment/{apartmentId}/temperature-control");
export const HeatcontrolMultiCommitResource = Vue.resource(API_ROOT + "heatcontrol/configuration/commit");
export const HeatcontrolMultiActivateResource = Vue.resource(API_ROOT + "heatcontrol/configuration/activate");
export const HeatcontrolAreaBindingsResource = Vue.resource(API_ROOT + "heatcontrol/area-bindings/{deviceId}");
export const HeatcontrolMultiResource = Vue.resource(API_ROOT + "heatcontrol/configuration/{deviceId}");
export const HeatcontrolMultiDiagnosticsResource = Vue.resource(API_ROOT + "heatcontrol/configuration/{deviceId}/diagnostics");
export const HeatcontrolLocalTestResource = Vue.resource(API_ROOT + "heatcontrol/configuration/{deviceId}/local-test");
export const HeatcontrolMultiStageResource = Vue.resource(API_ROOT + "heatcontrol/configuration/{deviceId}/{version}/stage");
export const HeatcontrolTransferCancelResource = Vue.resource(API_ROOT + "heatcontrol/configuration/{deviceId}/{version}/cancel-transfer");
export const HeatcontrolMultiRollbackResource = Vue.resource(API_ROOT + "heatcontrol/configuration/{deviceId}/rollback");

export const UserReadResource = Vue.resource(API_ROOT + "user/{id}");
export const UserResource = Vue.resource(API_ROOT + "user");
export const UserCreateResource = Vue.resource(API_ROOT + "user");
export const UserUpdateResource = Vue.resource(API_ROOT + "user/{id}");
export const UserUpdateDashboardSettingsResource = Vue.resource(API_ROOT + "user/update_dashboard_settings");

export const CreateEnergyUnitResource = Vue.resource(API_ROOT + "energyunit");
export const EnergyUnitResource = Vue.resource(API_ROOT + "energyunit");
export const EnergyUnitDeleteResource = Vue.resource(API_ROOT + "energyunit/{id}");
export const EnergyUnitDeactivateResource = Vue.resource(API_ROOT + "energyunit/deactivate/{id}");
export const EnergyUnitUpdateResource = Vue.resource(API_ROOT + "energyunit/{id}");
export const EnergyUnitHistoryResource = Vue.resource(API_ROOT + "energyunit/{id}");

export const GlobalResource = Vue.resource(API_ROOT + "global");
export const GlobalAllResource = Vue.resource(API_ROOT + "global/all");
export const GlobalUnusedResource = Vue.resource(API_ROOT + "global/unused");
export const GlobalCreateResource = Vue.resource(API_ROOT + "global");
export const GlobalUpdateResource = Vue.resource(API_ROOT + "global/{id}");
export const GlobalDeleteResource = Vue.resource(API_ROOT + "global/{id}");

export const PriceIndexResource = Vue.resource(API_ROOT + "price_index");
export const CreatePriceIndexResource = Vue.resource(API_ROOT + "price_index");
export const PriceIndexUpdateResource = Vue.resource(API_ROOT + "price_index/{id}");

export const CreateContractResource = Vue.resource(API_ROOT + "contract");
export const ContractResource = Vue.resource(API_ROOT + "contract");
export const ContractDeleteResource = Vue.resource(API_ROOT + "contract/{id}");
export const ContractDeactivateResource = Vue.resource(API_ROOT + "contract/deactivate/{id}");
export const ContractUpdateResource = Vue.resource(API_ROOT + "contract/{id}");
export const ContractHistoryResource = Vue.resource(API_ROOT + "contract/{id}");

export const EventallResetLocationResource = Vue.resource(API_ROOT + "event/reset/location");

export const InvoiceResource = Vue.resource(API_ROOT + "invoice/contract/{id}");
export const InvoiceDeleteResource = Vue.resource(API_ROOT + "invoice/rollback/{id}");
export const InvoiceProviderResource = Vue.resource(API_ROOT + "invoice/provider/{id}");
export const InvoiceCreateProviderResource = Vue.resource(API_ROOT + "invoice/create/provider/{id}");
export const InvoiceSendResource = Vue.resource(API_ROOT + "invoice/send/{id}");
export const InvoiceSendProviderAllResource = Vue.resource(API_ROOT + "invoice/send/provider/{id}");

export const DeviceSettingResource = Vue.resource(API_ROOT + "device_setting");
export const DeviceSettingCreateResource = Vue.resource(API_ROOT + "device_setting");
export const DeviceSettingUpdateResource = Vue.resource(API_ROOT + "device_setting/{id}");

export const LocationRawEventIndexResource = Vue.resource(API_ROOT + "raw_event{/deviceId}/index");

export const LocationPVForeCastResource = Vue.resource(API_ROOT + "forecast/pvloc");
export const HaSolarForeCastResource = Vue.resource(API_ROOT + "forecast/solarHa");

export const MixPriceForeCastResource = Vue.resource(API_ROOT + "forecast/getMixPrice");
export const MpcControlHistoryResource = Vue.resource(API_ROOT + "forecast/mpcControlHistory");
export const MpcCostOverviewResource = Vue.resource(API_ROOT + "forecast/mpcCostOverview");
export const ObsDatasetResource = Vue.resource(API_ROOT + "obs_dataset");

export const AlertResource = Vue.resource(API_ROOT + "alert");
export const AlertDeleteResource = Vue.resource(API_ROOT + "alert/{id}");
export const VapidPublicKeyResource = Vue.resource(API_ROOT + "push/vapid-public-key");
export const PushSubscriptionResource = Vue.resource(API_ROOT + "push/subscriptions");
export const PushUnsubscribeResource = Vue.resource(API_ROOT + "push/subscriptions/unsubscribe");

export const IconResource = Vue.resource(API_ROOT + "icon");
export const IconCreateResource = Vue.resource(API_ROOT + "icon");
export const IconUpdateResource = Vue.resource(API_ROOT + "icon/{id}");
export const IconDeleteResource = Vue.resource(API_ROOT + "icon/{id}");

export const InverterParamsResource = Vue.resource(API_ROOT + "device/control/inverter/{id}/params");
export const InverterControlResource = Vue.resource(API_ROOT + "device/control/inverter/{id}");

// Agent Resources
export const AgentConnectionsResource = Vue.resource(API_ROOT + "llm/connections");
export const AgentConnectionResource = Vue.resource(API_ROOT + "llm/connections/{id}");
export const AgentConnectionTestResource = Vue.resource(API_ROOT + "llm/connections/{id}/test");
export const AgentConnectionVisionTestResource = Vue.resource(API_ROOT + "llm/connections/{id}/vision-test");
export const AgentConnectionSetActiveResource = Vue.resource(API_ROOT + "llm/connections/{id}/setActive");
export const PlanImportSessionsResource = Vue.resource(API_ROOT + "plan-import/sessions");
export const PlanImportPackageImportResource = Vue.resource(API_ROOT + "plan-import/import");
export const PlanImportPackageExportResource = Vue.resource(API_ROOT + "plan-import/sessions/{id}/export");
export const PlanImportSessionResource = Vue.resource(API_ROOT + "plan-import/sessions/{id}");
export const PlanImportSessionArchiveResource = Vue.resource(API_ROOT + "plan-import/sessions/{id}/archive");
export const PlanImportFileResource = Vue.resource(API_ROOT + "plan-import/sessions/{id}/files/{fileId}");
export const PlanImportExternalResource = Vue.resource(API_ROOT + "plan-import/sessions/{id}/external-processing");
export const PlanImportAnalyzeResource = Vue.resource(API_ROOT + "plan-import/sessions/{id}/analyze");
export const PlanImportManualAnalysisResource = Vue.resource(API_ROOT + "plan-import/sessions/{id}/manual-analysis");
export const PlanImportReanalyzeResource = Vue.resource(API_ROOT + "plan-import/sessions/{id}/reanalyze-page");
export const PlanImportChatResource = Vue.resource(API_ROOT + "plan-import/sessions/{id}/chat");
export const PlanImportPatchResource = Vue.resource(API_ROOT + "plan-import/sessions/{id}/patch");
export const PlanImportPatchUndoResource = Vue.resource(API_ROOT + "plan-import/sessions/{id}/patch/undo");
export const PlanImportJobsResource = Vue.resource(API_ROOT + "plan-import/sessions/{id}/jobs");
export const PlanImportJobCancelResource = Vue.resource(API_ROOT + "plan-import/sessions/{id}/jobs/{jobId}/cancel");
export const PlanImportPreviewResource = Vue.resource(API_ROOT + "plan-import/sessions/{id}/preview");
export const PlanImportCommitResource = Vue.resource(API_ROOT + "plan-import/sessions/{id}/commit");
export const PlanImportRollbackPreviewResource = Vue.resource(API_ROOT + "plan-import/sessions/{id}/rollback/preview");
export const PlanImportRollbackResource = Vue.resource(API_ROOT + "plan-import/sessions/{id}/rollback");
export const PlanImportReopenResource = Vue.resource(API_ROOT + "plan-import/sessions/{id}/reopen");
export const PlanImportThermalProfilesResource = Vue.resource(API_ROOT + "plan-import/thermal-profiles");
export const PlanImportGoogleContextResource = Vue.resource(API_ROOT + "plan-import/google/context");
export const PlanImportAddressSearchResource = Vue.resource(API_ROOT + "plan-import/address/search");
export const PlanImportObstacleHeightResource = Vue.resource(API_ROOT + "plan-import/obstacle-height");
export const PlanImportSunPathResource = Vue.resource(API_ROOT + "plan-import/sun-path");
export const PlanImportProcessProfileResource = Vue.resource(API_ROOT + "plan-import/process-profile");
export const ElasticConnectionsResource = Vue.resource(API_ROOT + "elastic/connections");
export const ElasticConnectionResource = Vue.resource(API_ROOT + "elastic/connections/{id}");
export const ElasticConnectionTestResource = Vue.resource(API_ROOT + "elastic/connections/{id}/test");
export const ElasticConnectionSetActiveResource = Vue.resource(API_ROOT + "elastic/connections/{id}/setActive");

export const GatewayConfigurationResource = Vue.resource(API_ROOT + "gateways/{id}/config");
export const GatewayRetryResource = Vue.resource(API_ROOT + "gateways/{id}/config/retry");
export const RelayBoardConfigurationResource = Vue.resource(API_ROOT + "relayboards/{id}/config");
